import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layOut";
import HeroSection from "./components/HeroSection";
import BestSelling from "./components/BestSelling";
import TrendingPlants from "./components/TrendingPlants";
import Blogs from "./components/Blogs";
import Planters from "./components/Planters";
import Shop from "./components/Shop";
import LandscapeGardening from "./components/LandscapeGardening";
import Signup from "./components/RegistartionForm";
import SignIn from "./components/LoginFrom";
// import CelebsYouLove from "./components/CelebsYouLove";
import Cart from "./components/cart";
import Checkout from "./components/checkOut";
import AdminDashboard from "./components/AdminDasboard";
import AddProduct from "./pages/addProduct";
import Sidebar from "./pages/sideBar";
import ProductManager from "./pages/viewProducts";
import OrderDetails from "./pages/orderdetails";
import AdminLayout from "./pages/adminLayout";
import AdminOrderStats from "./pages/dashboardHome";
import PaymentSuccess from "./components/PaymentSucess";
import BlogDetail from "./components/DetailBlog";
import ImageSlider from "./components/ImageSlider";
import SearchResults from "./components/SearchResult";
import CategoryPage from "./components/CategoryPage";
import EmailConfigForm from "./pages/emails";
import MyProfile from "./components/MyProfile";
import MyOrders from "./components/MyOrders";
import RentPlants from "./components/Rental";
import AdminRentalRequests from "./pages/rentalrequest";
import CorporatePlantRentalForm from "./components/CorporateEnqiuryForm";
import CorporateRequests from "./pages/CorporateRequests";
import  EmailProviderForm  from "./pages/EmailProviderForm";
import GuestCheckout from "./components/Guestcheckout";
import GuestPaymentSuccess from "./components/GuestPaymentSuccess";
import ProductDetail from "./components/ProductDetail";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <ImageSlider/>
              <HeroSection />
              <BestSelling />
              <TrendingPlants />
              <Blogs />
              <Planters />
              <LandscapeGardening />
              {/* <CelebsYouLove /> */}
            </Layout>
          }
        />
        <Route path="/register" element={<Signup />} />
        <Route path="/email" element={ <Layout><EmailConfigForm /></Layout>} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="/search" element={<Layout><SearchResults /></Layout>} />
        <Route path="/category/:category" element={<Layout><CategoryPage /></Layout>} />
        <Route path="/rent" element={<Layout><RentPlants /></Layout>} />
        <Route path='/enquiryform' element={<Layout><CorporatePlantRentalForm/></Layout>}/>
        <Route path="/guest-checkout" element={<GuestCheckout/>}/>
        <Route path="/guest-success" element={<Layout><GuestPaymentSuccess/></Layout>}/>
        <Route path="/product/:id"element={<Layout><ProductDetail /></Layout>}/>

        <Route
          path="/plants"
          element={
            <Layout>
              <TrendingPlants />
            </Layout>
          }
        />
        <Route
          path="/planters"
          element={
            <Layout>
              <Planters />
            </Layout>
          }
        />
        <Route
          path="/blogs"
          element={
            <Layout>
              <Blogs />
            </Layout>
          }
        />
        <Route
          path="/shop"
          element={
            <Layout>
              <Shop />
            </Layout>
          }
        />
        <Route
          path="/cart"
          element={
            <Layout>
              <Cart />
            </Layout>
          }
        />
        <Route
          path="/checkout"
          element={
            <Layout>
              <Checkout />
            </Layout>
          }
        />
        <Route path="/profile" element={<Layout><MyProfile /></Layout>} />
        <Route path="/myorders" element={<Layout><MyOrders /></Layout>} />
        <Route path="/payment-success" element={<Layout><PaymentSuccess /></Layout>} />
        <Route path="/admin" element={<AdminOrderStats/>} />
        <Route path="/addproduct" element={<AddProduct />} />
        <Route path="/dash" element={<Sidebar />} />
        <Route path="/viewproduct" element={<ProductManager />} />
        <Route path="/orders" element={<OrderDetails />} />
        <Route path="/rentstatus" element={<AdminRentalRequests />} />
        <Route path="/stats" element={<AdminOrderStats />} />
        <Route path="/corporate" element={<CorporateRequests/>}/>
        <Route path="/emailprovider" element={<EmailProviderForm/>}/>

      </Routes>
    </Router>
  );
}

export default App;
